import storageService from "@/services/storage.service";
import { STORAGE_KEYS, ROLES } from "@/constants";

export default [
  // Applicant Default / Dashboard
  {
    path: "/",
    name: "default",
    meta: { authRequired: true },
    component: () => import("./views/applicant/dashboard"),
  },
  {
    path: "/membership_application",
    name: "membership_application",
    meta: {
      authRequired: true,
      nav: 1,
    },
    component: () => import("./views/applicant/membership_application"),
  },
  {
    path: "/membership_application_edit",
    name: "membership_application_edit",
    meta: {
      authRequired: true,
      nav: 1,
    },
    component: () => import("./views/applicant/membership_application_edit"),
  },
  {
    path: "/view_log",
    name: "View Log",
    meta: { authRequired: true },
    component: () => import("./views/applicant/view-log"),
  },
  {
    // the applicant's own submitted application, single-page summary (opened from the status log)
    path: "/my_application/:id",
    name: "my_application",
    meta: { authRequired: true, nav: 1 },
    component: () => import("./views/applicant/view_application"),
  },
  {
    path: "/notifications",
    name: "Notifications",
    meta: { authRequired: true },
    component: () => import("./views/applicant/notifications"),
  },

  // Authentication Routes
  {
    path: "/login",
    name: "login",
    component: () => import("./views/account/email"),
  },
  {
    path: "/staff_login",
    name: "staff_login",
    component: () => import("./views/account/email_staff"),
  },
  {
    path: "/forgot-password",
    name: "forgot_password",
    component: () => import("./views/account/forgot-password"),
  },
  {
    path: "/reset-password",
    name: "reset_password",
    component: () => import("./views/account/reset-password"),
  },
  {
    path: "/set-password",
    name: "set_password",
    component: () => import("./views/account/reset-password"),
  },
  {
    path: "/logout",
    name: "logout",
    component: () => import("./views/account/logout"),
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        storageService.removeItem(STORAGE_KEYS.ACCESS_TOKEN);
        storageService.removeItem(STORAGE_KEYS.REFRESH_TOKEN);
        if (storageService.getItem("userType") === ROLES.APPLICANT) {
          next({ name: "login" });
        } else {
          next({ path: "/staff_login?logout" });
        }
      },
    },
  },

  // Admin Routes
  {
    path: "/admin_dashboard",
    name: "admin dashaboard",
    meta: { authRequired: true },
    component: () => import("./views/admin/admin_dashboard"),
  },
  {
    path: "/staff_users",
    name: "Staff Users",
    meta: { authRequired: true },
    component: () => import("./views/admin/staff_users"),
  },
  {
    path: "/single_applicant/:id",
    name: "Single Applicant",
    meta: { authRequired: true },
    component: () => import("./views/admin/single_applicant"),
    props: true,
  },
  {
    path: "/applicants",
    name: "Applicants",
    meta: { authRequired: true },
    component: () => import("./views/admin/applicants"),
  },
  {
    path: "/admin_notifications",
    name: "Admin Notifications",
    meta: { authRequired: true },
    component: () => import("./views/admin/admin_notifications"),
  },
  {
    path: "/submit",
    name: "Submitted Under Review",
    meta: { authRequired: true },
    component: () => import("./views/admin/submitted_under"),
  },
  {
    path: "/admin_in_review",
    name: "In Review Applications",
    meta: { authRequired: true },
    component: () => import("./views/admin/in_review"),
  },
  {
    path: "/admin_verified",
    name: "Verified Applications",
    meta: { authRequired: true },
    component: () => import("./views/admin/verified"),
  },
  {
    path: "/archived_staff_members",
    alias: "/archived_staff_member",
    name: "Archived Staff Members",
    meta: { authRequired: true },
    component: () => import("./views/admin/archived_staff_member"),
  },
  {
    path: "/single_staff/:id",
    name: "Single Staff",
    meta: { authRequired: true },
    component: () => import("./views/admin/single_staff"),
  },
  {
    path: "/edit_staff/:id",
    name: "Edit Staff",
    meta: { authRequired: true },
    component: () => import("./views/admin/single_staff"),
  },

  // Staff & Reviewer Routes
  {
    path: "/application_list",
    name: "application list",
    meta: { authRequired: true },
    component: () => import("./views/staff/application_list.vue"),
  },
  {
    path: "/staff_view_log",
    name: "Staff View Log",
    meta: { authRequired: true },
    component: () => import("./views/staff/staff_view_log"),
  },
  {
    path: "/staff_dashboard",
    name: "Dashboard",
    meta: { authRequired: true },
    component: () => import("./views/staff/staff_dashboard"),
  },
  {
    path: "/approved_application",
    name: "Approved Application",
    meta: { authRequired: true },
    component: () => import("./views/staff/approved_application"),
  },
  {
    path: "/rejected_application",
    name: "Rejected Application",
    meta: { authRequired: true },
    component: () => import("./views/staff/rejected_application"),
  },
  {
    path: "/incomplete_application",
    name: "Incomplete Application",
    meta: { authRequired: true },
    component: () => import("./views/staff/incomplete_application"),
  },
  {
    path: "/pdf_data/:id",
    name: "PDF Application",
    meta: {
      authRequired: true,
      nav: 1,
    },
    component: () => import("./views/staff/pdfData"),
    props: (route) => ({ id: route.params.app_id || route.params.id }),
  },
  {
    path: "/view_application/:id",
    name: "view_application",
    meta: {
      authRequired: true,
      nav: 1,
    },
    component: () => import("./views/staff/membership_application"),
    props: (route) => ({ id: route.params.app_id || route.params.id }),
  },
  {
    path: "/review_application/:id",
    name: "review_application",
    meta: {
      authRequired: true,
      nav: 1,
    },
    component: () => import("./views/staff/membership_application"),
    props: (route) => ({ id: route.params.app_id || route.params.id }),
  },
  {
    path: "/staff_notification",
    name: "Staff Notification",
    meta: { authRequired: true },
    component: () => import("./views/staff/staff_notification"),
  },
  {
    path: "/my_profile",
    name: "My Profile",
    meta: { authRequired: true },
    component: () => import("./views/staff/staff_profile"),
  },
];